<template>
  <div class="p-0" :class="{ error: !!error }">
    <label v-if="label" class="form-label">{{ label }}:</label>

    <input
      ref="photoInput"
      type="file"
      :accept="accept"
      class="hidden"
      @change="updatePhotoPreview"
    />

    <!-- Current Cover -->
    <button v-show="!photoPreview" class="mt-2" @click.prevent="selectNewPhoto">
      <img
        v-if="value"
        :src="value"
        class="rounded-full h-20 w-20 object-cover cursor-pointer"
      />

      <div
        v-else
        class="w-20 h-20 border rounded-full border-gray-200 border-dashed"
      ></div>
    </button>

    <!-- New Cover Preview -->
    <div v-show="photoPreview" class="mt-2" @click.prevent="selectNewPhoto">
      <span
        class="
          block
          rounded-full
          w-20
          h-20
          bg-cover bg-no-repeat bg-center
          cursor-pointer
        "
        :style="'background-image: url(\'' + photoPreview + '\');'"
      />
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String,
    error: String,
    accept: String,
  },

  emits: ["updateCover"],

  data() {
    return {
      photoPreview: null,
    };
  },

  // mounted() {
  //   console.log(this.value)
  // },

  methods: {
    selectNewPhoto() {
      this.$refs.photoInput.click();
    },

    updatePhotoPreview() {
      const photo = this.$refs.photoInput.files[0];

      if (!photo) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        this.photoPreview = e.target.result;
      };

      reader.readAsDataURL(photo);

      this.$emit("updateCover", photo);
    },
  },
};
</script>
